import React from 'react';
import { DarkText } from '@lyearn-team/frontend-components';
import PropTypes from 'prop-types';
import * as s from './style';

class ChannelContent extends React.PureComponent {
  render() {
    const { title, date, description, isMobile, HTML_V2, darkTheme } = this.props;
    return (
      <div className={s.channelContentRoot(isMobile, HTML_V2, darkTheme)}>
        {title ? (
          <DarkText fontSize={20} className="title" fontSizeM={16}>
            {title}
          </DarkText>
        ) : null}
        {date ? (
          <DarkText color="zinc" fontSizeM={14}>
            {date}
          </DarkText>
        ) : null}
        {description ? (
          <DarkText className="description" color="copper">
            {description}
          </DarkText>
        ) : null}
      </div>
    );
  }
}

ChannelContent.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string
};
ChannelContent.defaultProps = {
  title: '',
  date: '',
  description: ''
};
export default ChannelContent;
